import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { ClinicService } from '../clinic.service';

export const useGetClinics = (
	params: Clinics.ClinicParams,
	options?: Omit<
		UseQueryOptions<Clinics.GetClinicsRespose, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: [
			'clinics',
			params.search,
			params.status,
			params.page,
			params.limit,
		],
		queryFn: () => ClinicService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetClinic = (
	id: string,
	options?: Omit<
		UseQueryOptions<Clinics.ClinicDetail, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['clinic', id],
		queryFn: () => ClinicService.getById(id),
		refetchOnWindowFocus: false,
		...options,
	});
};
